const appConfig = {
  apiPrefix: "/admin",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  enableMock: true,
};

export default appConfig;
